<template>
<div>
    <v-btn v-if="!drawer" style="margin-top:-5px" small elevation="5" color="#f5f5f5" absolute top left @click="drawer = !drawer; menuIzMin=false">
        <v-icon>mdi-menu</v-icon>
    </v-btn>

    <div @mouseleave="menuIzMin=true">
        <v-navigation-drawer id="menuIzq" v-model="drawer" hide-overlay width="250px" style="background-color:#f5f5f5" absolute :expand-on-hover="menuIzMin" @click="drawer = !drawer">
            <div class="pa-2">
                <v-btn elevation="0" block small @click="drawer = !drawer">
                    <v-icon color="primary">
                        mdi-menu
                    </v-icon>
                </v-btn>
            </div>

            <v-divider />

            <v-list dense nav left align="left">
                <v-list-item :to="menuList[0].ruta">
                    <v-list-item-icon>
                        <v-icon color="primary">
                            {{ menuList[0].icon }}
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{ menuList[0].nombre }}
                    </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="Auth" :to="menuList[1].ruta">
                    <v-list-item-icon>
                        <v-icon color="primary">
                            {{ menuList[1].icon }}
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{ menuList[1].nombre }}
                    </v-list-item-title>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'

export const Role = {
    Admin: 'Admin',
    User: 'User'
}

export default {
    components: {},
    data() {
        return {
            menuIzMin: true,
            drawer: true,

        }
    },
    computed: {
        ...mapState(['menuList', "Auth"]),
    },
    mounted() {
        

        // this.$router[2].meta.is_admin = true

    },

    methods: {
        ...mapActions({
            // signOutOidc: 'oidc/signOutOidc',
        }),

        pushR() {

        }

    }
}
</script>

<style scoped>
#menuIzq {
    -webkit-box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
    -moz-box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
}
</style>
